import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { LOGO_URL } from "@/config";

const LINKS = [
  { label: "Why We Run", href: "#why" },
  { label: "Every Mile", href: "#miles" },
  { label: "Register", href: "#register" },
  { label: "Schedule", href: "#schedule" },
  { label: "Volunteer", href: "#volunteers" },
  { label: "FAQ", href: "#faq" },
];

export const scrollToId = (href) => (e) => {
  e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 border-b border-black/5 bg-white/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 md:px-8">
        <a
          href="#top"
          onClick={scrollToId("#top")}
          data-testid="header-logo-link"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO_URL}
            alt="2Run4Hope logo"
            className="h-12 w-12 rounded-full object-cover shadow-sm ring-2 ring-hope-green/25"
          />
          <span className="font-heading text-lg font-bold tracking-tight text-hope-ink">
            2Run<span className="text-hope-green">4</span>Hope
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="header-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={scrollToId(l.href)}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-zinc-600 transition-colors duration-200 hover:text-hope-green"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#register-widget"
            onClick={scrollToId("#register-widget")}
            data-testid="header-register-btn"
            className="group hidden items-center gap-1.5 rounded-full bg-hope-green px-5 py-2.5 text-sm font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-hope-ink sm:inline-flex"
          >
            Register Now
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className="rounded-full p-2 text-hope-ink lg:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-black/5 bg-white px-4 py-4 lg:hidden" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={(e) => {
                scrollToId(l.href)(e);
                setOpen(false);
              }}
              className="block py-3 font-heading text-xl font-semibold text-hope-ink"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#register-widget"
            data-testid="mobile-register-btn"
            onClick={(e) => {
              scrollToId("#register-widget")(e);
              setOpen(false);
            }}
            className="mt-2 flex items-center justify-center gap-1.5 rounded-full bg-hope-green px-5 py-3 text-sm font-semibold text-white"
          >
            Register Now <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      )}
    </header>
  );
};
